import type { Board } from "../../../../../types/common";
import type { BoardDropdownOption } from "../../BoardDropdown/models/boardDropdownOption";
import type { DropdownOptionBase } from "../models/dropdownOptions";

export const formatToDropdownOption = <T extends { name: string; id: string | number }>(
  item: T
): DropdownOptionBase => {
  return { label: item.name, value: typeof item.id === "string" ? Number.parseInt(item.id) : item.id };
};

export const formatToBoardDropdownOption = ({ workspace, ...item }: Board): BoardDropdownOption => ({
  ...formatToDropdownOption(item),
  workspace: {
    id: workspace?.id,
    name: workspace?.name,
    color: workspace?.settings?.icon?.color,
    icon: workspace?.settings?.icon?.image,
  },
});
